import IcEqual from '@/assets/icons/ic-equal.svg';
import { ProductPayment } from '../types/transactionTypes';
import { useMemo } from 'react';
import { formatPreConversionAmountDisplay, getPaymentDisplayFlags } from '../income.logic';
import { STRIPE_PAYOUT_ERRORS_AND_RESPONSES_HTML } from '@/lib/constants';

export function TransactionCashoutDetails({ paymentData }: { paymentData: ProductPayment }) {
    const { showTaxAmount } = useMemo(() => {
        return getPaymentDisplayFlags(paymentData);
    }, [paymentData]);

    const payoutDetails = paymentData.pos_data?.payout_details || {};
    const failureCode = payoutDetails?.failure_code || '';
    let payoutErrorMessage = null;

    const upperFailureCode = failureCode.toUpperCase();
    if (upperFailureCode in STRIPE_PAYOUT_ERRORS_AND_RESPONSES_HTML) {
        // More readable stripe error messages: https://stripe.com/docs/api/payouts/object#payout_object-failure_code
        payoutErrorMessage =
            STRIPE_PAYOUT_ERRORS_AND_RESPONSES_HTML[
                upperFailureCode as keyof typeof STRIPE_PAYOUT_ERRORS_AND_RESPONSES_HTML
            ];
    }

    const posPreConversionAmountDisplay = useMemo(() => {
        return formatPreConversionAmountDisplay(paymentData);
    }, [paymentData]);

    return (
        <div className='flex w-full flex-row items-start p-0 md:flex-col'>
            <div className='flex grow'>
                <div className='flex w-full grow-0 items-start gap-2 p-0 md:w-fit md:flex-col md:pl-6'>
                    <div className='inline-flex h-full items-center pr-1 md:hidden'>
                        {showTaxAmount ? <IcEqual /> : <div className='w-3' />}
                    </div>
                    <div className='text-gray text-sm font-semibold'>Amount</div>
                    <div className='ml-auto font-bold'>{posPreConversionAmountDisplay}</div>
                </div>
                {payoutErrorMessage && (
                    <div className='grow-0'>
                        <div className='border-l-neutral-dark bg-neutral-main text-gray flex grow-0 flex-col items-start gap-3 rounded-xl p-4 pl-6 md:p-0'>
                            <div className='col-sm-12 font-semibold'>Error Details</div>
                            <div className='col-sm-12 text-align:start text-sm'>
                                <span dangerouslySetInnerHTML={{ __html: payoutErrorMessage }} />
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
